import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";

import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import References from "../../components/References";
import LdsBlockSteps from "../../components/LdsBlockSteps";
import scans from "../../assets/module-2/2-2-5-scans.png";
import IconSearch from "../../assets/components/blockStep/icon-search.svg";
import LdsImage from "../../components/LdsImage";
import FigureCaption from "../../components/LdsFigureCaption";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_2_2_1 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">
              2.2.5 Step 5: Determine if Scan is Positive or Negative
            </h1>
            <p className="me-4">Estimated time to complete: 1 minute</p>
          </section>

          <section className="row mt-5 mb-3 ms-3 justify-content-center align-items-center">
            <div className="col-12 mb-4 ">
              <LdsBlockSteps
                steps={[
                  {
                    number: 5,
                    color: "orange",
                    icon: IconSearch,
                    text: "Determine if scan is positive or negative",
                    boxType: "end",
                  },
                ]}
              />
            </div>
          </section>

          <seciton className="row justify-content-center">
            <div className="col-md-6 col-sm-12 align-items-center ">
              <FigureCaption
                noCollapse={true}
                className="figcaption-no-border align-items-center flex-column d-flex"
                radiusSize="small"
                textContent={
                  <>
                    <p className="dark-gray" style={{ maxWidth: "450px" }}>
                      &copy; 2016. Avid Radiopharmaceuticals, Inc. All rights reserved. Data on file, Lilly Research Laboratories: AMY20121001A, AMY20121001B.
                    </p>
                  </>
                }
              >
                <LdsImage
                  src={scans}
                  alt="Two brain scan images comparing Amyvid results. The left image shows a negative scan with no significant amyloid plaque buildup, while the right image shows a positive scan indicating the presence of amyloid plaques."
                  className="mb-2"
                  style={{ maxWidth: "450px" }}
                />
              </FigureCaption>

              <ul className="ms-0 mt-3">

                <li>
                  A negative scan shows more radioactivity in white matter than
                  in gray matter, creating clear gray-white contrast
                </li>
                <li>A positive scan must have <strong>one</strong> of the following:</li>
                <ul className="ms-0">
                  <li>2 or more brain areas (each larger than a single cortical gyrus) in which there is reduced or absent gray-white contrast. This is the most common appearance of a positive scan</li>
                </ul>
              </ul>
              OR
              <ul className="ms-0 mt-3">
                <ul className="ms-0">
                  <li>1 or more areas in which gray matter radioactivity is intense and clearly exceeds radioactivity in adjacent white matter</li>
                </ul>
              </ul>
            </div>
          </seciton>

          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-2/module-2-2-4", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-2/module-2-2-6", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>

          <References>
            <p className="fz-sm gray">
              Amyvid (florbetapir F 18 injection). Prescribing Information. Lilly USA, LLC.
            </p>
          </References>
        </main>
      </div>
    </div>
  );
};

export default Module_2_2_1;
